// extracted by mini-css-extract-plugin
export default {"plan-card":"FEQnAnBs"};